const defaultState = {
  supplier_id: null,
  supplier_item_id: null,
  item_name: '',
  description: '',
  item_code: '',
  unit_of_measure: 'each',
  quantity: 1,
  unit_cost: 0,
  currency: 'GBP',
  tax_rate: null,
  markup_percentage: null,
  lead_time_days: null,
  required_by_date: null,
  notes: '',
};

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'LOAD_PROCUREMENT_ITEM_FORM':
      return { ...defaultState, ...action.form };
    case 'CHANGE_PROCUREMENT_ITEM_FORM_FIELD':
      return { ...state, [action.field]: action.value };
    case 'RESET_PROCUREMENT_ITEM_FORM':
      return defaultState;
    default:
      return state;
  }
};
